import { BoxProps, IconProps } from '@chakra-ui/react';

export const navItemStyle = {
    py: 3,
    borderBottom: '2px solid',
    alignItems: 'center',
};

export const sideBarStyle: BoxProps = {
    zIndex: 9999,
    transition: 'all .7s ease',
    h: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    overflow: 'hidden',
    boxSizing: 'border-box',
    bg: 'blue.800',
};

export const diLogoStyle: IconProps = {
    position: 'absolute',
    top: '26px',
    left: '14px',
    w: '32px',
    h: '32px',
};
